import type { TrialMembership } from "@/stores/support/trials";

export type LeadFilter = "leads" | "trials" | "converted" | "suppressed" | "all";

export const leadFilters: LeadFilter[] = [
  "leads",
  "trials",
  "converted",
  "suppressed",
  "all",
];

export const isSuppressed = (lead: Pick<TrialMembership, "status">) =>
  lead.status === "rejected" || lead.status === "cancelled";

export const isConverted = (lead: Pick<TrialMembership, "status">) =>
  lead.status === "converted";

/** Same rule the old Trials page used: a dated trial, or any row that is not a pure lead/demo. */
export const isTrialListingRow = (
  row: Pick<TrialMembership, "trial_date" | "request_type">
) => {
  if (row.trial_date) return true;
  if (row.request_type === "lead" || row.request_type === "demo") return false;
  return true;
};

export const matchesLeadFilter = (
  lead: Pick<TrialMembership, "status" | "trial_date" | "request_type">,
  filter: LeadFilter
): boolean => {
  if (filter === "all") return true;
  if (filter === "converted") return isConverted(lead);
  if (filter === "suppressed") return isSuppressed(lead);
  if (filter === "trials") return isTrialListingRow(lead);
  // Open prospects only. Trial rows live under the Trials filter.
  return !isSuppressed(lead) && !isConverted(lead) && !isTrialListingRow(lead);
};
